import { render, staticRenderFns } from "./DrawerTeacher.vue?vue&type=template&id=772d9600&scoped=true"
import script from "./DrawerTeacher.vue?vue&type=script&lang=js"
export * from "./DrawerTeacher.vue?vue&type=script&lang=js"
import style0 from "./DrawerTeacher.vue?vue&type=style&index=0&id=772d9600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772d9600",
  null
  
)

export default component.exports